import { render, staticRenderFns } from "./SensorNotificationsLimits.vue?vue&type=template&id=a2503bac&scoped=true&"
import script from "./SensorNotificationsLimits.vue?vue&type=script&lang=js&"
export * from "./SensorNotificationsLimits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2503bac",
  null
  
)

export default component.exports